import { TFunction } from 'i18next'

import { TYPE_TRANSFERS } from 'shared/constants'

export const ListTransfers = [
  {
    key: TYPE_TRANSFERS.WITHOUT,
    title: 'without_transfer',
  },
  {
    key: TYPE_TRANSFERS.ONE,
    title: 'one_transfer',
  },
  {
    key: TYPE_TRANSFERS.TWO,
    title: 'two_transfer',
  },
  {
    key: TYPE_TRANSFERS.ANY,
    title: 'any_transfer',
  },
]

export const getListTransfers = (t: TFunction) =>
  ListTransfers.map((item) => ({
    ...item,
    title: t(item.title),
  }))
